import React from 'react';
import { ImageIcon } from 'lucide-react';
export function GallerySection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-293">
      <div className="max-w-[680px] mx-auto" data-id="element-294">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-295">
          Mirá algunos de los modelos exactos del ebook
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-296">
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-297">
            <img src="https://cdn.magicpatterns.com/uploads/tRRHkMK6j2hGNx5hR74Ne5/crochet1.png" alt="Modelo de bikini al crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-298" />
          </div>
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-299">
            <img src="https://cdn.magicpatterns.com/uploads/37iPtj9P4p817wRJ8qoUNk/crochet2.png" alt="Modelo de bikini al crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-300" />
          </div>
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-301">
            <img src="https://cdn.magicpatterns.com/uploads/syAGoVvSmrCiiGRGTmVCwj/crochet3.png" alt="Modelo de crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-302" />
          </div>
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-303">
            <img src="https://cdn.magicpatterns.com/uploads/4ujqEbRzuDqZhvpiGhXH1M/crochet4.png" alt="Modelo de bikini al crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-304" />
          </div>
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-305">
            <img src="https://cdn.magicpatterns.com/uploads/uTw5J7jvvG59Tp6RLEqcuq/crochet5.png" alt="Modelo de bikini al crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-306" />
          </div>
          <div className="aspect-[3/4] bg-pink-soft rounded-2xl overflow-hidden" data-id="element-307">
            <img src="https://cdn.magicpatterns.com/uploads/5FkivrSFcwHu6XVFfB55D2/crochet6.png" alt="Modelo de bikini al crochet incluido en el ebook" className="w-full h-full object-cover" data-id="element-308" />
          </div>
        </div>

        <p className="text-center italic text-medium-gray font-body text-sm mt-6" data-id="element-309">
          📸 Hechos por mujeres principiantes. Siguiendo exactamente este
          método.
        </p>
      </div>
    </section>;
}